var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 147,
    fill: "#2B2B2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_1744)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6869,
    transform: "translate(-136 -6451)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 482,
    transform: "translate(-136 -64)",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.244 35.0488L122.222 18.4689C136.364 30.9895 145.143 48.4738 146.737 67.2944C148.332 86.115 142.62 104.827 130.786 119.549C118.953 134.27 101.906 143.871 83.1825 146.359C64.4591 148.847 45.4964 144.032 30.2286 132.912C14.9608 121.792 4.55993 105.221 1.1838 86.6376C-2.19232 68.0537 1.71548 48.8834 12.0965 33.1039C22.4775 17.3244 38.5348 6.14698 56.937 1.89061C75.3392 -2.36576 94.6737 0.625658 110.929 10.2442L99.0817 26.8894C99.0789 26.8879 99.076 26.8863 99.0732 26.8847L73.0081 63.307L79.2596 75.4679L93.2605 55.5987C96.1351 64.312 98.9804 72.9226 101.807 81.4755L101.814 81.4985L101.815 81.5016C105.049 91.2883 108.258 100.999 111.458 110.702C112.452 109.69 113.409 108.636 114.326 107.54C122.976 97.1967 127.368 83.9501 126.61 70.4877C125.852 57.0253 120.001 44.3555 110.244 35.0488ZM109.383 112.701L90.5443 89.2472L79.7077 104.514C76.6555 100.697 73.8553 97.1612 71.0552 93.5971C67.6197 89.2141 64.1818 84.8311 60.7414 80.4481L37.7163 112.623C39.1532 113.939 40.6678 115.182 42.2555 116.342C53.141 124.299 66.6459 127.818 80.0302 126.183C91.0344 124.839 101.28 120.094 109.383 112.701ZM25.2759 95.5023C23.5178 91.6462 22.2144 87.5647 21.415 83.3356C18.9107 70.0865 21.5405 56.3808 28.7706 44.9995C36.0008 33.6181 47.2899 25.4135 60.3474 22.0503C66.2077 20.5408 72.2272 20.0573 78.152 20.568L25.2759 95.5023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 6869,
    fill: "white",
    transform: "translate(-136 -6451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.1c466308f0a1d9a6d7d49017676d410a.svg";
export { ForwardRef as ReactComponent };